<template>
  <div id="NoNotifications" class="brand-text">No Notifications to show</div>
</template>

<script>
export default {
  name: "NoNotifications"
};
</script>

<style lang="less">
#NoNotifications {
  font-family: "PlusJakartaSansRegular";
  font-size: 1.6rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
}
</style>
